export const YesNo = [
    { value: '1', text: "Yes" },
    { value: '0', text: "No" },
]

export const PrivateGroup = [
    { value: 'private', text: "Private" },
    { value: 'group', text: "Group" },
]

export const Gender = [
    { value: 'M', text: "Male" },
    { value: 'F', text: "Female" },
]

export const Color = [
    { value: '', text: "default" },
    { value: 'strong-pink', text: "strong-pink" },
    { value: 'barney', text: "barney" },
    { value: 'purply', text: "purply" },
    { value: 'purpleish-blue', text: "purpleish-blue" },
    { value: 'cornflower-blue', text: "cornflower-blue" },
    { value: 'greeny-blue', text: "greeny-blue" },
    { value: 'weird-green', text: "weird-green" },
    { value: 'lightgreen', text: "lightgreen" },
    { value: 'straw', text: "straw" },
    { value: 'pale-orange', text: "pale-orange" },
    { value: 'pale', text: "pale" }
]

export const WeekDay = [
    { value: 'MON', text: "Mon" },
    { value: 'TUE', text: "Tue" },
    { value: 'WED', text: "Wed" },
    { value: 'THU', text: "Thu" },
    { value: 'FRI', text: "Fri" },
    { value: 'SAT', text: "Sat" },
    { value: 'SUN', text: "Sun" },
]

export const Nationality = [
    { value: 'singapore', text: "Singapore Citizen" },
    { value: 'singaporepr', text: "Singapore PR" },
    { value: 'others', text: "Others" },
]

export const NationalityMY = [
    { value: 'malaysia', text: "Malaysian Citizen" },
    { value: 'malaysiapr', text: "Malaysian PR" },
    { value: 'others', text: "Others" },
]

export const UserType = [
    { value: 'supervisor', text: "Supervisor" },
    { value: 'customer', text: "Customer" },
    { value: 'instructor', text: "Instructor" },
    { value: 'coordinator', text: "Coordinator" },
]

export const PromoType = [
    { value: 'value', text: "Value" },
    { value: 'percentage', text: "Percentage" },
]

export const Designation = [
    { value: 'general', text: "General" },
    { value: 'e_voucher', text: "E-Voucher" },
]

export const PromoStatus = [
    { value: 'active', text: "Active" },
    { value: 'inactive', text: "Inactive" },
    { value: 'expired', text: "Expired" },
    { value: 'revoked', text: "Revoked" },
]

export const StripeAccountMY = [
    { value: 'default', text: "Default"},
]

export const StripeAccount = [
    { value: 'default', text: "Default" },
    { value: 'steven', text: "Stevens" },
    { value: 'bedok', text: "Bedok" },
    // { value: 'demo', text: "Demo" },
]